import { render } from "./current-delivery-address.vue?vue&type=template&id=201cace0"
import script from "./current-delivery-address.vue?vue&type=script&lang=js"
export * from "./current-delivery-address.vue?vue&type=script&lang=js"

import "./current-delivery-address.vue?vue&type=style&index=0&id=201cace0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__